const headCellsListCustomer = [
    {
        id: 'FullName',
        numeric: false,
        disablePadding: false,
        label: 'Họ và tên',
        className: 'pt-3 pb-3',
        style: { minWidth: "150px" }
    },
    {
        id: 'IsActived',
        numeric: false,
        disablePadding: false,
        label: 'Hoạt động',
        className: 'pt-3 pb-3',
    },
    {
        id: 'YearOfBirth',
        numeric: false,
        disablePadding: false,
        label: 'Năm sinh',
        className: 'pt-3 pb-3',
    },
    {
        id: 'department.Name',
        numeric: false,
        disablePadding: false,
        label: 'Độ tuổi (ban)',
        className: 'pt-3 pb-3',
        style: { minWidth: "80px" }
    },
    {
        id: 'District.Name',
        numeric: false,
        disablePadding: true,
        label: 'Quận/Huyện',
        className: 'pt-3 pb-3',
    },
    {
        id: 'PhoneNumber',
        numeric: false,
        disablePadding: true,
        label: 'Điện thoại',
        className: 'pt-3 pb-3',
    },
    {
        id: 'Herdsman1.LastName',
        numeric: false,
        disablePadding: true,
        label: 'ACE dẫn dắt',
        className: 'pt-3 pb-3',
        style: { minWidth: "100px" }
    },
    {
        id: 'Status',
        numeric: false,
        disablePadding: false,
        label: 'Trạng thái hiện tại',
        className: 'pt-3 pb-3',
        style: {minWidth: "70px"}
    },
    {
        id: 'buoc1_Actual',
        numeric: false,
        disablePadding: true,
        label: 'Các bước',
        className: 'pt-3 pb-3',
        style: { minWidth: "170px" }
    },
    {
        id: 'Career',
        numeric: false,
        disablePadding: false,
        label: 'Nghề nghiệp',
        className: 'pt-3 pb-3',
    },
    {
        id: 'Description',
        numeric: false,
        disablePadding: true,
        label: 'Ghi chú',
        className: 'pt-3 pb-3',
        style: { minWidth: "200px" }
    },

    {
        id: 'action',
        numeric: false,
        disablePadding: true,
        label: '',
        className: 'pt-3 pb-3 pl-4',
    },
];

export default headCellsListCustomer;